export default __webpack_public_path__ + "media/assets/images/google_play-0f9053eff0646c297d0aeb635f2bc57f.png";